import React, { Fragment } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../components/header';
import Head from '../../../components/head';
import Footer from '../../../components/footer';
import ListaContratosExpoAnt from '../../../components/contratos/listar/expomacuco';


function ListaContratosExpoAntScreen() {
    return (
        <Fragment>
            <Head titulo="Contratos Firmados para a Expo Macuco em anos anteriores a 2023" />
            <Header />
            <Container>
                <ListaContratosExpoAnt />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default ListaContratosExpoAntScreen;